import { i18n } from '@lingui/core';

export const getTranslations = () => ({
    SELECT: i18n._('challenges.level.select'),
    LEVEL: i18n._('challenges.level.label')
});
